import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/apps/blogtostart/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SignupForm"] */ "/root/apps/blogtostart/src/app/(auth)/auth-forms.tsx");
